// (function () {
//   var running = false;
//   var syncing = false;
//   var observerBound = false;

//   function getCart(callback) {
//     fetch('/cart.js')
//       .then(function (response) {
//         return response.json();
//       })
//       .then(callback)
//       .catch(function () {
//         callback({ items: [] });
//       });
//   }

//   function sellingPlanId(item) {
//     if (item && item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
//       return String(item.selling_plan_allocation.selling_plan.id);
//     }
//     return '';
//   }

//   function itemProps(item) {
//     return item && item.properties ? item.properties : {};
//   }

//   function isBundleChild(item) {
//     if (itemProps(item)._bundle_role === 'child') return true;
//     if (item.parent_relationship && item.parent_relationship.parent) return true;
//     return false;
//   }

//   function isBundleParent(item, items) {
//     if (isBundleChild(item)) return false;
//     if (itemProps(item)._bundle_role === 'parent') return true;

//     return items.some(function (other) {
//       if (!isBundleChild(other)) return false;
//       return parentKeyForChild(other, items) === item.key;
//     });
//   }

//   function parentKeyForChild(child, items) {
//     var bundleId = itemProps(child)._bundle_id;
//     if (bundleId) {
//       var parent = items.find(function (item) {
//         return itemProps(item)._bundle_role === 'parent' && itemProps(item)._bundle_id === bundleId;
//       });
//       if (parent) return parent.key;

//       parent = items.find(function (item) {
//         return !isBundleChild(item) && itemProps(item)._bundle_id === bundleId;
//       });
//       if (parent) return parent.key;
//     }

//     var rel = child.parent_relationship && child.parent_relationship.parent;
//     if (rel && rel.key && items.some(function (item) { return item.key === rel.key; })) {
//       return rel.key;
//     }

//     if (rel && rel.variant_id) {
//       var byVariant = items.find(function (item) {
//         return !isBundleChild(item) && String(item.variant_id) === String(rel.variant_id);
//       });
//       if (byVariant) return byVariant.key;
//     }

//     return null;
//   }

//   function lineEls(root) {
//     return Array.prototype.slice.call(
//       root.querySelectorAll('.rebuy-cart__flyout-item')
//     );
//   }

//   function elKey(el) {
//     return (
//       el.getAttribute('data-item_key') ||
//       el.getAttribute('data-item-key') ||
//       el.getAttribute('data-key') ||
//       el.dataset.item_key ||
//       el.dataset.itemKey ||
//       ''
//     );
//   }

//   function elVariantId(el) {
//     return (
//       el.getAttribute('data-variant_id') ||
//       el.getAttribute('data-variant-id') ||
//       el.dataset.variant_id ||
//       el.dataset.variantId ||
//       ''
//     );
//   }

//   function matchLineEl(item, els, used) {
//     var i;
//     var key = item.key;

//     for (i = 0; i < els.length; i++) {
//       if (used.has(els[i])) continue;
//       if (key && elKey(els[i]) === key) return els[i];
//     }

//     for (i = 0; i < els.length; i++) {
//       if (used.has(els[i])) continue;
//       if (elVariantId(els[i]) && String(elVariantId(els[i])) === String(item.variant_id)) {
//         return els[i];
//       }
//     }

//     return null;
//   }

//   function escapeHtml(value) {
//     return String(value)
//       .replace(/&/g, '&amp;')
//       .replace(/</g, '&lt;')
//       .replace(/>/g, '&gt;')
//       .replace(/"/g, '&quot;');
//   }

//   function childImage(item) {
//     if (item.image) return item.image;
//     if (item.featured_image && item.featured_image.url) return item.featured_image.url;
//     return '';
//   }

//   function childVariantLabel(item) {
//     if (item.variant_title && item.variant_title !== 'Default Title') {
//       return item.variant_title;
//     }
//     return '';
//   }

//   function formatMoney(cents) {
//     if (typeof theme !== 'undefined' && theme.Currency && theme.Currency.formatMoney) {
//       return theme.Currency.formatMoney(cents, theme.settings && theme.settings.moneyFormat);
//     }
//     return '$' + (Number(cents) / 100).toFixed(2);
//   }

//   function setParentPrice(parentEl, cents) {
//     var money = parentEl.querySelector('.rebuy-cart__flyout-item-price .rebuy-money, .rebuy-money');
//     if (!money) return;

//     var visible = money.querySelector('span:not(.sr-only)');
//     if (visible) {
//       visible.textContent = formatMoney(cents);
//       return;
//     }

//     money.textContent = formatMoney(cents);
//   }

//   function buildChildrenMarkup(children) {
//     var html = '<p class="rebuy-bundle-includes">Includes</p><ul class="rebuy-bundle-children">';

//     children.forEach(function (child) {
//       var img = childImage(child);
//       var variant = childVariantLabel(child);
//       var plan = child.selling_plan_allocation && child.selling_plan_allocation.selling_plan
//         ? child.selling_plan_allocation.selling_plan.name
//         : '';

//       html += '<li class="rebuy-bundle-child">';
//       if (img) {
//         html += '<div class="rebuy-bundle-child-image"><img src="' + img + '" alt="" width="40" height="40" loading="lazy"></div>';
//       }
//       html += '<div class="rebuy-bundle-child-info">';
//       html += '<span class="rebuy-bundle-child-title">' + escapeHtml(child.product_title || '') + '</span>';
//       if (variant) {
//         html += '<span class="rebuy-bundle-child-variant">' + escapeHtml(variant) + '</span>';
//       }
//       if (plan) {
//         html += '<span class="rebuy-bundle-child-subscription">' + escapeHtml(plan) + '</span>';
//       }
//       html += '</div></li>';
//     });

//     html += '</ul>';
//     return html;
//   }

//   function updateHeaderCartCount(cart) {
//     if (!cart) return;

//     var count = Number(cart.item_count) || 0;

//     var countEls = document.querySelectorAll('.cart-link__bubble-num');

//     countEls.forEach(function (el) {
//       el.innerText = String(count);
//     });

//     var itemLabel = 'items';
//     if (typeof theme !== 'undefined' && theme.strings && theme.strings.cartItems) {
//       itemLabel = String(theme.strings.cartItems).replace('[count]', String(count));
//     } else if (count === 1) {
//       itemLabel = '1 item';
//     } else {
//       itemLabel = count + ' items';
//     }

//     document.querySelectorAll('#rebuy-cart-title, .rebuy-cart__flyout-title, [data-rebuy-component="cart-title"]').forEach(function (el) {
//       el.textContent = 'Subtotal (' + itemLabel + ')';
//     });

//     document.querySelectorAll('.cart-link__bubble').forEach(function (bubble) {
//       if (count > 0) {
//         bubble.classList.add('cart-link__bubble--visible');
//       } else {
//         bubble.classList.remove('cart-link__bubble--visible');
//       }
//     });

//     if (count > 0) {
//       document.body.classList.add('cart-has-items');
//     } else {
//       document.body.classList.remove('cart-has-items');
//     }

//     document.dispatchEvent(new CustomEvent('cart:updated', {
//       detail: { cart: cart }
//     }));
//   }

//   function nestRebuyBundleLines(cart) {
//     if (cart) updateHeaderCartCount(cart);

//     var root = document.querySelector('#rebuy-cart');
//     if (!root || !cart || !Array.isArray(cart.items) || !cart.items.length) return;
//     if (running) return;
//     running = true;

//     try {
//       var items = cart.items;
//       var childrenByParent = {};
//       var childKeys = {};
//       var parentKeys = {};

//       items.forEach(function (item) {
//         if (!isBundleChild(item)) return;
//         var parentKey = parentKeyForChild(item, items);
//         if (!parentKey) return;
//         childKeys[item.key] = true;
//         parentKeys[parentKey] = true;
//         if (!childrenByParent[parentKey]) childrenByParent[parentKey] = [];
//         childrenByParent[parentKey].push(item);
//       });

//       items.forEach(function (item) {
//         if (isBundleParent(item, items)) parentKeys[item.key] = true;
//       });

//       if (!Object.keys(parentKeys).length) {
//         lineEls(root).forEach(function (el) {
//           el.classList.remove('property-value-parent', 'property-value-child', 'rebuy-bundle-child-line', 'rebuy-bundle-parent-line');
//           var extra = el.querySelector('.rebuy-bundle-includes-wrap');
//           if (extra) extra.remove();
//         });
//         return;
//       }

//       var els = lineEls(root);
//       var used = new Set();

//       items.forEach(function (item) {
//         var el = matchLineEl(item, els, used);
//         if (!el) return;
//         used.add(el);

//         el.classList.remove('property-value-parent', 'property-value-child', 'rebuy-bundle-child-line', 'rebuy-bundle-parent-line');

//         if (childKeys[item.key]) {
//           var leftover = el.querySelector('.rebuy-bundle-includes-wrap');
//           if (leftover) leftover.remove();
//           if (parentKeys[parentKeyForChild(item, items)]) {
//             el.classList.add('property-value-child', 'rebuy-bundle-child-line');
//           }
//           return;
//         }

//         if (!parentKeys[item.key]) {
//           var wrap = el.querySelector('.rebuy-bundle-includes-wrap');
//           if (wrap) wrap.remove();
//           return;
//         }

//         el.classList.add('property-value-parent', 'rebuy-bundle-parent-line');

//         var children = childrenByParent[item.key] || [];
//         if (!children.length) return;

//         var mount =
//           el.querySelector('.rebuy-cart__flyout-item-product-title') ||
//           el.querySelector('.rebuy-cart__flyout-item-info') ||
//           el.querySelector('.rebuy-cart__flyout-item-product');

//         if (!mount) return;

//         var box = el.querySelector('.rebuy-bundle-includes-wrap');
//         if (!box) {
//           box = document.createElement('div');
//           box.className = 'rebuy-bundle-includes-wrap';
//           mount.parentNode.insertBefore(box, mount.nextSibling);
//         }
//         box.innerHTML = buildChildrenMarkup(children);

//         var total = Number(item.final_line_price || item.line_price || 0);
//         children.forEach(function (child) {
//           total += Number(child.final_line_price || child.line_price || 0);
//         });
//         setParentPrice(el, total);
//       });
//     } finally {
//       running = false;
//     }
//   }

//   function childrenForParent(parent, items) {
//     return items.filter(function (item) {
//       return isBundleChild(item) && parentKeyForChild(item, items) === parent.key;
//     });
//   }

//   function refreshRebuyCart() {
//     if (window.Rebuy && Rebuy.Cart && typeof Rebuy.Cart.fetch === 'function') {
//       Rebuy.Cart.fetch();
//       return;
//     }
//     if (window.Rebuy && Rebuy.SmartCart && typeof Rebuy.SmartCart.reload === 'function') {
//       Rebuy.SmartCart.reload();
//     }
//   }

//   function cartJsonHeaders() {
//     return {
//       'Content-Type': 'application/json',
//       'X-Requested-With': 'XMLHttpRequest'
//     };
//   }

//   function changeLine(key, quantity, planId) {
//     var body = {
//       id: key,
//       quantity: Number(quantity)
//     };

//     if (planId) {
//       body.selling_plan = planId;
//     } else {
//       body.selling_plan = '';
//     }

//     return fetch('/cart/change.js', {
//       method: 'POST',
//       headers: cartJsonHeaders(),
//       body: JSON.stringify(body)
//     }).then(function (response) {
//       return response.json();
//     });
//   }

//   function applyCartUpdates(updates, callback) {
//     fetch('/cart/update.js', {
//       method: 'POST',
//       headers: cartJsonHeaders(),
//       body: JSON.stringify({ updates: updates })
//     })
//       .then(function (response) {
//         return response.json();
//       })
//       .then(function (cart) {
//         updateHeaderCartCount(cart);
//         refreshRebuyCart();
//         if (callback) callback(cart);
//       })
//       .catch(function () {
//         if (callback) callback(null);
//       });
//   }

//   function runLineChanges(changes, callback) {
//     var index = 0;
//     var lastCart = null;

//     function next() {
//       if (index >= changes.length) {
//         updateHeaderCartCount(lastCart);
//         refreshRebuyCart();
//         if (callback) callback(lastCart);
//         return;
//       }

//       var change = changes[index];
//       index += 1;
//       changeLine(change.key, change.quantity, change.selling_plan)
//         .then(function (cart) {
//           lastCart = cart;
//           next();
//         })
//         .catch(function () {
//           if (callback) callback(lastCart);
//         });
//     }

//     next();
//   }

//   function syncBundleChildren(cart) {
//     if (syncing || !cart || !Array.isArray(cart.items)) return;

//     var items = cart.items;
//     var qtyUpdates = {};
//     var planChanges = [];
//     var hasQtyUpdates = false;

//     items.forEach(function (item) {
//       if (!isBundleParent(item, items)) return;

//       var parentPlan = sellingPlanId(item);
//       childrenForParent(item, items).forEach(function (child) {
//         var qtyDiff = Number(child.quantity) !== Number(item.quantity);
//         var planDiff = sellingPlanId(child) !== parentPlan;

//         if (planDiff) {
//           planChanges.push({
//             key: child.key,
//             quantity: Number(item.quantity),
//             selling_plan: parentPlan
//           });
//         } else if (qtyDiff) {
//           qtyUpdates[child.key] = Number(item.quantity);
//           hasQtyUpdates = true;
//         }
//       });
//     });

//     items.forEach(function (item) {
//       if (!isBundleChild(item)) return;
//       if (parentKeyForChild(item, items)) return;
//       if (itemProps(item)._bundle_id) return;
//       qtyUpdates[item.key] = 0;
//       hasQtyUpdates = true;
//     });

//     if (!planChanges.length && !hasQtyUpdates) return;

//     syncing = true;
//     var finish = function (nextCart) {
//       syncing = false;
//       if (nextCart) nestRebuyBundleLines(nextCart);
//     };

//     if (planChanges.length) {
//       runLineChanges(planChanges, function (nextCart) {
//         if (hasQtyUpdates && nextCart) {
//           applyCartUpdates(qtyUpdates, finish);
//           return;
//         }
//         finish(nextCart);
//       });
//       return;
//     }

//     applyCartUpdates(qtyUpdates, finish);
//   }

//   function bindRebuyListObserver() {
//     if (observerBound) return;

//     var list = document.querySelector(
//       '#rebuy-cart [data-smartcart-items], #rebuy-cart .rebuy-cart__flyout-items'
//     );
//     if (!list) return;

//     observerBound = true;
//     var observer = new MutationObserver(function () {
//       if (running || syncing) return;
//       getCart(function (cart) {
//         nestRebuyBundleLines(cart);
//       });
//     });
//     observer.observe(list, { childList: true });
//   }

//   function applyCart(cart) {
//     nestRebuyBundleLines(cart);
//     syncBundleChildren(cart);
//     bindRebuyListObserver();
//   }

//   function onCartEvent() {
//     if (syncing) return;

//     getCart(function (latestCart) {
//       applyCart(latestCart);
//       requestAnimationFrame(function () {
//         nestRebuyBundleLines(latestCart);
//       });
//     });
//   }

//   document.addEventListener('rebuy:smartcart.show', onCartEvent);
//   document.addEventListener('rebuy:cart.add', onCartEvent);
//   document.addEventListener('rebuy:cart.change', onCartEvent);
//   document.addEventListener('rebuy:cart.ready', onCartEvent);
// })();
(function () {
  var running = false;
  var syncing = false;
  var suppressObserver = false;
  var listObserver = null;
  var observerTarget = null;
  var observerTimer = null;
  var lastSnapshot = null;
  var syncTimer = null;
  var settleTimer = null;

  function getCart(callback) {
    fetch('/cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(callback)
      .catch(function () {
        callback({ items: [] });
      });
  }

  function sellingPlanId(item) {
    if (item && item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
      return String(item.selling_plan_allocation.selling_plan.id);
    }
    return '';
  }

  function itemProps(item) {
    return item && item.properties ? item.properties : {};
  }

  function isShellParent(item) {
    return itemProps(item)._bundle_role === 'parent';
  }

  function isBundleChild(item) {
    if (itemProps(item)._bundle_role === 'child') return true;
    if (item.parent_relationship && item.parent_relationship.parent) return true;
    return false;
  }

  function bundleIdOf(item) {
    return itemProps(item)._bundle_id || '';
  }

  function buildSnapshot(items) {
    var snap = {};
    (items || []).forEach(function (item) {
      snap[item.key] = {
        qty: Number(item.quantity),
        bundleId: bundleIdOf(item),
        role: itemProps(item)._bundle_role || '',
        plan: sellingPlanId(item)
      };
    });
    return snap;
  }

  function childrenByBundleId(items) {
    var groups = {};
    items.forEach(function (item) {
      if (!isBundleChild(item)) return;
      var id = bundleIdOf(item);
      if (!id) return;
      if (!groups[id]) groups[id] = [];
      groups[id].push(item);
    });
    return groups;
  }

  function sortBundleChildren(children) {
    return children.slice().sort(function (a, b) {
      var slotA = Number(itemProps(a)._bundle_slot) || 99;
      var slotB = Number(itemProps(b)._bundle_slot) || 99;
      return slotA - slotB;
    });
  }

  function virtualLeader(children) {
    var sorted = sortBundleChildren(children);
    return sorted[0] || null;
  }

  function shellParentForBundle(items, bundleId) {
    var found = null;
    items.forEach(function (item) {
      if (found) return;
      if (isShellParent(item) && bundleIdOf(item) === bundleId) found = item;
    });
    return found;
  }

  function isLegacyParent(item, items) {
    if (isBundleChild(item) || isShellParent(item)) return false;
    return items.some(function (other) {
      if (!isBundleChild(other)) return false;
      var rel = other.parent_relationship && other.parent_relationship.parent;
      return rel && rel.key === item.key;
    });
  }

  function lineEls(root) {
    return Array.prototype.slice.call(
      root.querySelectorAll('.rebuy-cart__flyout-item')
    );
  }

  function elKey(el) {
    return (
      el.getAttribute('data-item_key') ||
      el.getAttribute('data-item-key') ||
      el.getAttribute('data-key') ||
      el.dataset.item_key ||
      el.dataset.itemKey ||
      ''
    );
  }

  function elVariantId(el) {
    return (
      el.getAttribute('data-variant_id') ||
      el.getAttribute('data-variant-id') ||
      el.dataset.variant_id ||
      el.dataset.variantId ||
      ''
    );
  }

  function normalizeBundleToken(value) {
    return String(value || '').toLowerCase().replace(/[^a-z0-9]/g, '');
  }

  function elPropertyToken(el, propName) {
    var prefix = 'property-' + propName + ':';
    var classes = String(el.className || '').split(/\s+/);
    for (var i = 0; i < classes.length; i++) {
      if (classes[i].indexOf(prefix) === 0) {
        return classes[i].slice(prefix.length);
      }
    }
    return '';
  }

  function elBundleMeta(el) {
    return {
      bundleId: elPropertyToken(el, '_bundle_id'),
      slot: elPropertyToken(el, '_bundle_slot'),
      role: elPropertyToken(el, '_bundle_role')
    };
  }

  function matchLineEl(item, els, used) {
    var i;
    var key = item.key;
    var props = itemProps(item);
    var wantId = normalizeBundleToken(props._bundle_id);
    var wantSlot = String(props._bundle_slot || '');

    for (i = 0; i < els.length; i++) {
      if (used.has(els[i])) continue;
      if (key && elKey(els[i]) === key) return els[i];
    }

    for (i = 0; i < els.length; i++) {
      if (used.has(els[i])) continue;
      if (elVariantId(els[i]) && String(elVariantId(els[i])) === String(item.variant_id)) {
        return els[i];
      }
    }

    if (wantId && wantSlot) {
      for (i = 0; i < els.length; i++) {
        if (used.has(els[i])) continue;
        var meta = elBundleMeta(els[i]);
        if (normalizeBundleToken(meta.bundleId) === wantId && String(meta.slot) === wantSlot) {
          return els[i];
        }
      }
    }

    return null;
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function childImage(item) {
    if (item.image) return item.image;
    if (item.featured_image && item.featured_image.url) return item.featured_image.url;
    return '';
  }

  function childVariantLabel(item) {
    if (item.variant_title && item.variant_title !== 'Default Title') {
      return item.variant_title;
    }
    return '';
  }

  function formatMoney(cents) {
    if (typeof theme !== 'undefined' && theme.Currency && theme.Currency.formatMoney) {
      return theme.Currency.formatMoney(cents, theme.settings && theme.settings.moneyFormat);
    }
    return '$' + (Number(cents) / 100).toFixed(2);
  }

  function setParentPrice(parentEl, cents) {
    var money = parentEl.querySelector('.rebuy-cart__flyout-item-price .rebuy-money, .rebuy-money');
    if (!money) return;

    var visible = money.querySelector('span:not(.sr-only)');
    if (visible) {
      visible.textContent = formatMoney(cents);
      return;
    }

    money.textContent = formatMoney(cents);
  }

  function setDisplayTitle(el, title) {
    if (!title) return;
    var titleEl =
      el.querySelector('.rebuy-cart__flyout-item-product-title a') ||
      el.querySelector('.rebuy-cart__flyout-item-product-title') ||
      el.querySelector('.rebuy-product-title-link');
    if (titleEl) titleEl.textContent = title;
  }

  function resolveDisplayImage(imageUrl) {
    if (!imageUrl) return '';
    var url = String(imageUrl).trim();
    if (!url || url.indexOf('1/0000/0000') !== -1) return '';
    if (url.indexOf('//') === 0) return window.location.protocol + url;
    if (url.charAt(0) === '/') return window.location.origin + url;
    return url;
  }

  function setDisplayImage(el, imageUrl) {
    var url = resolveDisplayImage(imageUrl);
    if (!url) return;
    var img = el.querySelector('.rebuy-cart__flyout-item-media img, .rebuy-cart__flyout-item-image img, img');
    if (!img) return;
    if (img.getAttribute('data-bundle-display-src') === url && img.getAttribute('src') === url) return;
    img.setAttribute('data-bundle-display-src', url);
    img.removeAttribute('srcset');
    img.src = url;
  }

  function hideVariantTitle(el) {
    var variant = el.querySelector('.rebuy-cart__flyout-item-variant-title');
    if (variant) variant.style.display = 'none';
  }

  function buildChildrenMarkup(children) {
    var html = '<p class="rebuy-bundle-includes">Includes</p><ul class="rebuy-bundle-children">';

    sortBundleChildren(children).forEach(function (child) {
      var img = childImage(child);
      var variant = childVariantLabel(child);
      var plan = child.selling_plan_allocation && child.selling_plan_allocation.selling_plan
        ? child.selling_plan_allocation.selling_plan.name
        : '';

      html += '<li class="rebuy-bundle-child">';
      if (img) {
        html += '<div class="rebuy-bundle-child-image"><img src="' + img + '" alt="" width="40" height="40" loading="lazy"></div>';
      }
      html += '<div class="rebuy-bundle-child-info">';
      html += '<span class="rebuy-bundle-child-title">' + escapeHtml(child.product_title || '') + '</span>';
      if (variant) {
        html += '<span class="rebuy-bundle-child-variant">' + escapeHtml(variant) + '</span>';
      }
      if (plan) {
        html += '<span class="rebuy-bundle-child-subscription">' + escapeHtml(plan) + '</span>';
      }
      html += '</div></li>';
    });

    html += '</ul>';
    return html;
  }

  function isListBundle(item, children) {
    if (itemProps(item)._bundle_view === 'curie-bundle-list') return true;
    return (children || []).some(function (child) {
      return itemProps(child)._bundle_view === 'curie-bundle-list';
    });
  }

  function bundleEditHref(item, children) {
    if (!item || !isListBundle(item, children)) return '';
    var props = itemProps(item);
    var base = props._bundle_display_url || (item.handle ? '/products/' + item.handle : '');
    if (!base) return '';
    base = String(base).split('?')[0];

    var sorted = sortBundleChildren(children);
    var ids = [];
    var plan = '';
    sorted.forEach(function (child) {
      if (child.variant_id) ids.push(child.variant_id);
      if (!plan) plan = sellingPlanId(child);
    });

    var params = new URLSearchParams();
    params.set('view', 'curie-bundle-list');
    if (ids.length) params.set('edit_slots', ids.join(','));
    var bundleId = bundleIdOf(item);
    if (bundleId) params.set('edit_bundle', bundleId);
    params.set('edit_plan', plan || '');
    return base + '?' + params.toString();
  }

  function updateHeaderCartCount(cart) {
    if (!cart) return;

    var count = Number(cart.item_count) || 0;

    document.querySelectorAll('.cart-link__bubble-num').forEach(function (el) {
      el.innerText = String(count);
    });

    var itemLabel = 'items';
    if (typeof theme !== 'undefined' && theme.strings && theme.strings.cartItems) {
      itemLabel = String(theme.strings.cartItems).replace('[count]', String(count));
    } else if (count === 1) {
      itemLabel = '1 item';
    } else {
      itemLabel = count + ' items';
    }

    document.querySelectorAll('#rebuy-cart-title, .rebuy-cart__flyout-title, [data-rebuy-component="cart-title"]').forEach(function (el) {
      el.textContent = 'Subtotal (' + itemLabel + ')';
    });

    document.querySelectorAll('.cart-link__bubble').forEach(function (bubble) {
      if (count > 0) {
        bubble.classList.add('cart-link__bubble--visible');
      } else {
        bubble.classList.remove('cart-link__bubble--visible');
      }
    });

    if (count > 0) {
      document.body.classList.add('cart-has-items');
    } else {
      document.body.classList.remove('cart-has-items');
    }
  }

  function nestSignature(children, totalCents, displayTitle, displayImage) {
    var parts = [
      String(displayTitle || ''),
      resolveDisplayImage(displayImage),
      String(totalCents || 0)
    ];
    sortBundleChildren(children).forEach(function (child) {
      parts.push(
        [
          child.key,
          child.quantity,
          sellingPlanId(child),
          child.product_title || '',
          childVariantLabel(child)
        ].join('~')
      );
    });
    return parts.join('|');
  }

  function mountIncludes(el, children, totalCents, displayTitle, displayImage, parentItem) {
    var editHref = bundleEditHref(parentItem, children);
    var sig = nestSignature(children, totalCents, displayTitle, displayImage) + '|' + editHref;
    if (el.getAttribute('data-bundle-nest-sig') === sig && el.querySelector('.rebuy-bundle-includes-wrap')) {
      setDisplayImage(el, displayImage);
      return;
    }

    setDisplayTitle(el, displayTitle);
    setDisplayImage(el, displayImage);
    hideVariantTitle(el);

    var mount =
      el.querySelector('.rebuy-cart__flyout-item-product-title') ||
      el.querySelector('.rebuy-cart__flyout-item-info') ||
      el.querySelector('.rebuy-cart__flyout-item-product');

    if (!mount) return;

    var box = el.querySelector('.rebuy-bundle-includes-wrap');
    if (!box) {
      box = document.createElement('div');
      box.className = 'rebuy-bundle-includes-wrap';
      mount.parentNode.insertBefore(box, mount.nextSibling);
    }
    box.innerHTML = buildChildrenMarkup(children);
    if (editHref) {
      var editLink = document.createElement('a');
      editLink.className = 'rebuy-bundle-edit';
      editLink.href = editHref;
      editLink.textContent = 'Edit Bundle';
      box.appendChild(editLink);
    }
    setParentPrice(el, totalCents);
    el.setAttribute('data-bundle-nest-sig', sig);
  }

  function nestRebuyBundleLines(cart) {
    if (cart) updateHeaderCartCount(cart);

    var root = document.querySelector('#rebuy-cart');
    if (!root || !cart || !Array.isArray(cart.items) || !cart.items.length) return;
    if (running) return;
    running = true;
    suppressObserver = true;

    try {
      var items = cart.items;
      var groups = childrenByBundleId(items);
      var els = lineEls(root);
      var used = new Set();
      var hasBundle = Object.keys(groups).length > 0 || items.some(isShellParent) || items.some(function (item) {
        return isLegacyParent(item, items);
      });

      if (!hasBundle) {
        els.forEach(function (el) {
          el.classList.remove('property-value-parent', 'property-value-child', 'rebuy-bundle-child-line', 'rebuy-bundle-parent-line');
          el.removeAttribute('data-bundle-nest-sig');
          var extra = el.querySelector('.rebuy-bundle-includes-wrap');
          if (extra) extra.remove();
        });
        return;
      }

      items.forEach(function (item) {
        var el = matchLineEl(item, els, used);
        if (!el) return;
        used.add(el);
        el.classList.remove('property-value-parent', 'property-value-child', 'rebuy-bundle-child-line', 'rebuy-bundle-parent-line');

        if (isShellParent(item)) {
          var shellId = bundleIdOf(item);
          var shellChildren = groups[shellId] || [];
          el.classList.add('property-value-parent', 'rebuy-bundle-parent-line');
          var shellTotal = Number(item.final_line_price || item.line_price || 0);
          shellChildren.forEach(function (child) {
            shellTotal += Number(child.final_line_price || child.line_price || 0);
          });
          mountIncludes(el, shellChildren, shellTotal, item.product_title, childImage(item), item);
          return;
        }

        if (isLegacyParent(item, items)) {
          var legacyChildren = items.filter(function (child) {
            var rel = child.parent_relationship && child.parent_relationship.parent;
            return rel && rel.key === item.key;
          });
          el.classList.add('property-value-parent', 'rebuy-bundle-parent-line');
          var legacyTotal = Number(item.final_line_price || item.line_price || 0);
          legacyChildren.forEach(function (child) {
            legacyTotal += Number(child.final_line_price || child.line_price || 0);
          });
          mountIncludes(el, legacyChildren, legacyTotal, item.product_title, childImage(item), item);
          return;
        }

        if (!isBundleChild(item)) {
          var wrap = el.querySelector('.rebuy-bundle-includes-wrap');
          if (wrap) wrap.remove();
          el.removeAttribute('data-bundle-nest-sig');
          return;
        }

        var id = bundleIdOf(item);
        var children = groups[id] || [];
        if (shellParentForBundle(items, id)) {
          el.classList.add('property-value-child', 'rebuy-bundle-child-line');
          var shellLeftover = el.querySelector('.rebuy-bundle-includes-wrap');
          if (shellLeftover) shellLeftover.remove();
          el.removeAttribute('data-bundle-nest-sig');
          return;
        }
        var leader = virtualLeader(children);

        if (!leader || leader.key !== item.key) {
          el.classList.add('property-value-child', 'rebuy-bundle-child-line');
          var leftover = el.querySelector('.rebuy-bundle-includes-wrap');
          if (leftover) leftover.remove();
          el.removeAttribute('data-bundle-nest-sig');
          return;
        }

        el.classList.add('property-value-parent', 'rebuy-bundle-parent-line');
        var props = itemProps(leader);
        var total = 0;
        children.forEach(function (child) {
          total += Number(child.final_line_price || child.line_price || 0);
        });
        mountIncludes(
          el,
          children,
          total,
          props._bundle_display_title || leader.product_title,
          props._bundle_display_image || '',
          leader
        );
      });
    } finally {
      running = false;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          suppressObserver = false;
        });
      });
    }
  }

  function refreshRebuyCart() {
    if (window.Rebuy && Rebuy.Cart && typeof Rebuy.Cart.fetch === 'function') {
      Rebuy.Cart.fetch();
      return;
    }
    if (window.Rebuy && Rebuy.SmartCart && typeof Rebuy.SmartCart.reload === 'function') {
      Rebuy.SmartCart.reload();
    }
  }

  function cartJsonHeaders() {
    return {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    };
  }

  function changeLine(key, quantity, planId) {
    var body = {
      id: key,
      quantity: Number(quantity)
    };

    if (planId) {
      body.selling_plan = planId;
    } else {
      body.selling_plan = '';
    }

    return fetch('/cart/change.js', {
      method: 'POST',
      headers: cartJsonHeaders(),
      body: JSON.stringify(body)
    }).then(function (response) {
      return response.json();
    });
  }

  function applyCartUpdates(updates, callback) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: cartJsonHeaders(),
      body: JSON.stringify({ updates: updates })
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        updateHeaderCartCount(cart);
        refreshRebuyCart();
        if (typeof theme !== 'undefined' && document.querySelector('#CartDrawerForm, form.cart__form, .cart__items')) {
          document.dispatchEvent(new CustomEvent('cart:build'));
        }
        if (callback) callback(cart);
      })
      .catch(function () {
        if (callback) callback(null);
      });
  }

  function runLineChanges(changes, callback) {
    var index = 0;
    var lastCart = null;

    function next() {
      if (index >= changes.length) {
        updateHeaderCartCount(lastCart);
        refreshRebuyCart();
        if (callback) callback(lastCart);
        return;
      }

      var change = changes[index];
      index += 1;
      changeLine(change.key, change.quantity, change.selling_plan)
        .then(function (cart) {
          lastCart = cart;
          next();
        })
        .catch(function () {
          if (callback) callback(lastCart);
        });
    }

    next();
  }

  function countPrevBundleChildren(prev, bundleId) {
    var count = 0;
    Object.keys(prev || {}).forEach(function (key) {
      var row = prev[key];
      if (row && row.bundleId === bundleId && row.role === 'child') count += 1;
    });
    return count;
  }

  function syncBundleChildren(cart) {
    if (syncing || !cart || !Array.isArray(cart.items)) return;

    var items = cart.items;
    var current = buildSnapshot(items);
    var prev = lastSnapshot;
    var qtyUpdates = {};
    var planChanges = [];
    var hasQtyUpdates = false;
    var groups = childrenByBundleId(items);

    Object.keys(groups).forEach(function (id) {
      var children = sortBundleChildren(groups[id]);
      if (!children.length) return;

      var parent = shellParentForBundle(items, id);
      if (parent) {
        var parentQty = Number(parent.quantity);
        var parentPlan = sellingPlanId(parent);

        if (parentQty <= 0) {
          children.forEach(function (child) {
            qtyUpdates[child.key] = 0;
            hasQtyUpdates = true;
          });
          return;
        }

        children.forEach(function (child) {
          var planDiff = parentPlan && sellingPlanId(child) !== parentPlan;
          var qtyDiff = Number(child.quantity) !== parentQty;

          if (planDiff) {
            planChanges.push({
              key: child.key,
              quantity: parentQty,
              selling_plan: parentPlan
            });
            return;
          }

          if (qtyDiff) {
            qtyUpdates[child.key] = parentQty;
            hasQtyUpdates = true;
          }
        });
        return;
      }

      var leader = children[0];
      var currCount = children.length;
      var hasSlotOne = children.some(function (child) {
        return String(itemProps(child)._bundle_slot) === '1';
      });
      var maxSlot = 0;
      children.forEach(function (child) {
        var slot = Number(itemProps(child)._bundle_slot) || 0;
        if (slot > maxSlot) maxSlot = slot;
      });

      // Incomplete visual set only (do not use key-count dips — plan/one-time rotates keys)
      if (!hasSlotOne || (maxSlot > 0 && currCount < maxSlot)) {
        children.forEach(function (child) {
          qtyUpdates[child.key] = 0;
          hasQtyUpdates = true;
        });
        return;
      }

      // Visual qty / plan source of truth = slot-1 leader row only
      var targetQty = Number(leader.quantity);
      var targetPlan = sellingPlanId(leader);

      if (targetQty <= 0) {
        children.forEach(function (child) {
          qtyUpdates[child.key] = 0;
          hasQtyUpdates = true;
        });
        return;
      }

      children.forEach(function (child) {
        var planDiff = sellingPlanId(child) !== targetPlan;
        var qtyDiff = Number(child.quantity) !== targetQty;

        if (planDiff) {
          planChanges.push({
            key: child.key,
            quantity: targetQty,
            selling_plan: targetPlan
          });
          return;
        }

        if (qtyDiff) {
          qtyUpdates[child.key] = targetQty;
          hasQtyUpdates = true;
        }
      });
    });

    if (!planChanges.length && !hasQtyUpdates) {
      lastSnapshot = current;
      return;
    }

    syncing = true;
    var finish = function (nextCart) {
      syncing = false;
      if (nextCart && nextCart.items) {
        lastSnapshot = buildSnapshot(nextCart.items);
        nestRebuyBundleLines(nextCart);
      } else {
        getCart(function (fresh) {
          lastSnapshot = buildSnapshot(fresh.items || []);
          nestRebuyBundleLines(fresh);
        });
      }
    };

    if (planChanges.length) {
      runLineChanges(planChanges, function (nextCart) {
        if (hasQtyUpdates && Object.keys(qtyUpdates).length) {
          applyCartUpdates(qtyUpdates, finish);
          return;
        }
        finish(nextCart);
      });
      return;
    }

    applyCartUpdates(qtyUpdates, finish);
  }

  function bindRebuyListObserver() {
    var list = document.querySelector(
      '#rebuy-cart [data-smartcart-items], #rebuy-cart .rebuy-cart__flyout-items'
    );
    if (!list) return;

    // Rebuy replaces the list node — rebind when target changes
    if (listObserver && observerTarget === list) return;

    if (listObserver) {
      listObserver.disconnect();
      listObserver = null;
    }

    observerTarget = list;
    listObserver = new MutationObserver(function (mutations) {
      if (suppressObserver || running || syncing) return;

      var relevant = mutations.some(function (mutation) {
        return mutation.type === 'childList' && (mutation.addedNodes.length || mutation.removedNodes.length);
      });
      if (!relevant) return;

      if (observerTimer) clearTimeout(observerTimer);
      observerTimer = setTimeout(function () {
        getCart(function (cart) {
          nestRebuyBundleLines(cart);
        });
      }, 250);
    });

    // childList only — subtree caused endless nest/blink loops
    listObserver.observe(list, { childList: true });
  }

  function bindRebuyPlanSync() {
    if (document.documentElement.dataset.bundlePlanSyncBound === 'true') return;
    document.documentElement.dataset.bundlePlanSyncBound = 'true';

    document.addEventListener(
      'change',
      function (event) {
        var select = event.target;
        if (!select || !select.closest) return;
        if (!select.closest('#rebuy-cart')) return;
        if (!select.closest('.rebuy-bundle-parent-line, .rebuy-cart__flyout-item')) return;

        var isPlanSelect =
          select.matches('select') &&
          (select.getAttribute('aria-label') || '').toLowerCase().indexOf('subscription') !== -1;

        if (!isPlanSelect && !(select.name || '').match(/selling|frequency|plan/i)) {
          if (!select.closest('.rebuy-bundle-parent-line') && !select.closest('[class*="property-_bundle_role:child"]')) {
            return;
          }
        }

        scheduleSync();
      },
      true
    );
  }

  function scheduleSync() {
    if (syncing) return;
    if (syncTimer) clearTimeout(syncTimer);
    if (settleTimer) clearTimeout(settleTimer);
    syncTimer = setTimeout(function () {
      getCart(function (latestCart) {
        nestRebuyBundleLines(latestCart);
        syncBundleChildren(latestCart);
        bindRebuyListObserver();
        bindRebuyPlanSync();
        // One settle pass after Rebuy redraw — not a loop
        settleTimer = setTimeout(function () {
          getCart(function (cart) {
            nestRebuyBundleLines(cart);
            bindRebuyListObserver();
          });
        }, 500);
      });
    }, 300);
  }

  function applyCart(cart) {
    nestRebuyBundleLines(cart);
    syncBundleChildren(cart);
    bindRebuyListObserver();
  }

  function onCartEvent() {
    scheduleSync();
  }

  document.addEventListener('rebuy:smartcart.show', onCartEvent);
  document.addEventListener('rebuy:cart.add', onCartEvent);
  document.addEventListener('rebuy:cart.change', onCartEvent);
  document.addEventListener('rebuy:cart.ready', onCartEvent);
  document.addEventListener('cart:updated', onCartEvent);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onCartEvent);
  } else {
    onCartEvent();
  }
})();

// Rebuy's /products/static payload can omit selling plans on a new product.
// The Smart Cart switch only renders when the line variant has allocations.
(function () {
  var cache = {};
  var tries = 0;

  function lineVariantId(item) {
    return Number(item.variant_id || item.id);
  }

  function annotatePlan(plan) {
    return Object.assign({}, plan, {
      order_interval_frequency: plan.name,
      order_interval_unit_type: 'month'
    });
  }

  function annotateGroups(groups) {
    return (groups || []).map(function (group) {
      return Object.assign({}, group, {
        selling_plans: (group.selling_plans || []).map(annotatePlan)
      });
    });
  }

  function needsRepair(item) {
    var product = item && item.product;
    var variant = product && product.selected_variant;
    if (!variant) return false;
    var allocs = variant.selling_plan_allocations;
    if (!allocs || !allocs.length || !product.has_subscription) return true;
    var subscribed = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
    if (subscribed && !product.subscription) return true;
    if (subscribed && !product.subscription_frequency) return true;
    return false;
  }

  function plansForVariant(shopifyProduct, variantId) {
    var variant = (shopifyProduct.variants || []).filter(function (entry) {
      return Number(entry.id) === Number(variantId);
    })[0];
    if (!variant || !(variant.selling_plan_allocations || []).length) return null;

    var groupIds = {};
    variant.selling_plan_allocations.forEach(function (alloc) {
      groupIds[String(alloc.selling_plan_group_id)] = true;
    });

    var plans = [];
    (shopifyProduct.selling_plan_groups || []).forEach(function (group) {
      if (!groupIds[String(group.id)]) return;
      (group.selling_plans || []).forEach(function (plan) {
        var used = variant.selling_plan_allocations.some(function (alloc) {
          return String(alloc.selling_plan_id) === String(plan.id);
        });
        if (used) plans.push(plan);
      });
    });

    if (!plans.length) return null;
    return {
      allocations: variant.selling_plan_allocations,
      plans: plans.map(annotatePlan),
      groups: annotateGroups(shopifyProduct.selling_plan_groups)
    };
  }

  function clearSubscription(item) {
    var product = item && item.product;
    if (!product || !product.has_subscription && !(product.selling_plan_groups || []).length) return false;

    product.has_subscription = false;
    product.selling_plan_groups = [];
    product.subscription = false;
    product.subscription_id = null;
    product.subscription_frequency = '';
    product.subscription_frequencies = [];

    var variantId = lineVariantId(item);
    (product.variants || []).forEach(function (variant) {
      if (Number(variant.id) !== variantId) return;
      variant.selling_plan_allocations = [];
      variant.selling_plans = [];
      variant.subscription_frequencies = [];
    });

    if (product.selected_variant && Number(product.selected_variant.id) === variantId) {
      product.selected_variant.selling_plan_allocations = [];
      product.selected_variant.selling_plans = [];
      product.selected_variant.subscription_frequencies = [];
    }

    return true;
  }

  function patchItem(item, shopifyProduct) {
    var built = plansForVariant(shopifyProduct, lineVariantId(item));
    if (!built) return clearSubscription(item);
    if (!needsRepair(item)) return false;

    var product = item.product;
    var variantId = lineVariantId(item);
    var selected = null;

    product.selling_plan_groups = built.groups;
    product.has_subscription = true;

    (product.variants || []).forEach(function (variant) {
      if (Number(variant.id) !== variantId) return;
      variant.selling_plan_allocations = built.allocations;
      variant.selling_plans = built.plans;
      variant.subscription_frequencies = built.plans.map(function (plan) {
        return plan.name;
      });
      selected = variant;
    });

    if (!selected) return false;

    product.selected_variant = selected;
    product.selected_variant_id = selected.id;
    product.subscription_frequencies = selected.subscription_frequencies;

    if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
      product.subscription = true;
      product.subscription_id = item.selling_plan_allocation.selling_plan.id;
      product.subscription_frequency = item.selling_plan_allocation.selling_plan.name;
    } else {
      product.subscription = false;
    }

    return true;
  }

  function refreshCartView() {
    var smart = window.Rebuy && window.Rebuy.SmartCart;
    var view = smart && smart.view;
    if (view && typeof view.$forceUpdate === 'function') view.$forceUpdate();
  }

  function repair(cart) {
    var items = (cart && cart.items) || [];
    var handles = {};

    items.forEach(function (item) {
      var product = item && item.product;
      var hasPlans = product && (product.has_subscription || (product.selling_plan_groups || []).length);
      if (!needsRepair(item) && !hasPlans) return;
      var handle = item.handle || (product && product.handle);
      if (handle) handles[handle] = true;
    });

    Object.keys(handles).forEach(function (handle) {
      var run = function (shopifyProduct) {
        var changed = false;
        items.forEach(function (item) {
          var itemHandle = item.handle || (item.product && item.product.handle);
          if (itemHandle !== handle) return;
          if (patchItem(item, shopifyProduct)) changed = true;
        });
        if (changed) refreshCartView();
      };

      if (cache[handle]) {
        run(cache[handle]);
        return;
      }

      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (shopifyProduct) {
          cache[handle] = shopifyProduct;
          run(shopifyProduct);
        })
        .catch(function () {});
    });
  }

  function wrapEnrich() {
    var cartApi = window.Rebuy && window.Rebuy.Cart;
    if (!cartApi || typeof cartApi.enrichCart !== 'function') return false;
    if (cartApi.__ttPlansWrapped) {
      repair(cartApi.cart);
      return true;
    }

    var original = cartApi.enrichCart.bind(cartApi);
    cartApi.enrichCart = function (callback) {
      return original(function () {
        repair(cartApi.cart);
        if (typeof callback === 'function') callback();
      });
    };
    cartApi.__ttPlansWrapped = true;
    repair(cartApi.cart);
    return true;
  }

  function boot() {
    if (wrapEnrich() || tries > 20) return;
    tries += 1;
    setTimeout(boot, 300);
  }

  document.addEventListener('rebuy.loaded', boot);
  document.addEventListener('rebuy:cart.ready', boot);
  document.addEventListener('rebuy:smartcart.show', boot);
  document.addEventListener('rebuy:cart.change', function () {
    var cartApi = window.Rebuy && window.Rebuy.Cart;
    if (!cartApi) return;
    repair(cartApi.cart);
    setTimeout(function () { repair(cartApi.cart); }, 400);
    setTimeout(function () { repair(cartApi.cart); }, 1000);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
